import React from 'react';
import {
  Box,
  VStack,
  Text,
  Spinner,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

interface WaitingForExamProps {
  pollExamStatus?: () => void;
}

export const WaitingForExam: React.FC<WaitingForExamProps> = () => {
  const { t } = useTranslation();

  return (
    <Box
      testID="mcq-waiting-screen"
      flex={1}
      justifyContent="center"
      alignItems="center"
      p="$6"
    >
      <VStack space="lg" alignItems="center">
        <Spinner size="large" />
        <Text size="xl" bold textAlign="center">
          {t('student.mcq.waitingForExam')}
        </Text>
        <Text color="$textSubtle" textAlign="center">
          {t('student.mcq.joinMeetingFirst')}
        </Text>
        <Box
          bg="$info50"
          borderLeftWidth={4}
          borderLeftColor="$info500"
          p="$3"
          borderRadius="$sm"
          width="100%"
        >
          <Text size="sm" color="$info700">
            {t('student.mcq.waitForLecturerVerification')}
          </Text>
        </Box>
      </VStack>
    </Box>
  );
};

export default WaitingForExam;
